// Viewport class and width bucket attached to every browser analytics event.
// Width is the layout viewport. The buckets match the same edges as the class.

const BUCKETS = [
  { max: 480, bucket: "0_479", device: "mobile" },
  { max: 768, bucket: "480_767", device: "mobile" },
  { max: 1024, bucket: "768_1023", device: "tablet" },
  { max: 1280, bucket: "1024_1279", device: "desktop" },
];

export function deviceContext(width) {
  const value = Number(width);
  if (!Number.isFinite(value) || value <= 0) return { device: "", viewport_bucket: "" };
  for (let index = 0; index < BUCKETS.length; index += 1) {
    const row = BUCKETS[index];
    if (value < row.max) return { device: row.device, viewport_bucket: row.bucket };
  }
  return { device: "desktop", viewport_bucket: "1280_plus" };
}

export function currentDeviceContext() {
  if (typeof window === "undefined") return { device: "", viewport_bucket: "" };
  return deviceContext(window.innerWidth);
}
